module.exports = __webpack_public_path__ + "static/media/yourspace-min.5f9e3077.png";